import Text from "components/Text";
import { FC, useEffect, useState } from "react";
import { WithStyle } from "utils/WithStyle";
import { Tab, TabSelectionWrapper } from "./TabSelection.styled";
import { TabSelectionProps } from "./types";

const Component: FC<TabSelectionProps> = ({
    options,
    defaultActive,
    onChange,
}) => {
    const [activeTab, setActiveTab] = useState(defaultActive);

    useEffect(() => {
        if (options && options?.length > 0 && !defaultActive) {
            setActiveTab(options[0].value);
        }
    }, [defaultActive, options]);

    const handleClick = (tab: string) => {
        setActiveTab(tab);
        onChange && onChange(tab);
    };

    useEffect(() => {
        setActiveTab(defaultActive);
    }, [defaultActive]);
    return (
        <TabSelectionWrapper>
            {options?.map((option) => (
                <Tab
                    isActive={activeTab === option.value}
                    onClick={() => handleClick(option.value || "")}
                >
                    <Text variant="body3">{option.label}</Text>
                </Tab>
            ))}
        </TabSelectionWrapper>
    );
};

export const TabSelection: FC<TabSelectionProps> & WithStyle = Object.assign(
    Component,
    {
        Style: TabSelectionWrapper,
    }
);
